import {BillingInterval} from '~/api/types/billing'
import Country from '~/locale/country'

import type {AdditionalUsersPricing} from '../types'

/**
 * All countries except DK and SE
 */
const GENERIC_COUNTRIES: Country[] = Object.values(Country).filter(
    (country) => country !== Country.DK && country !== Country.SE,
)

/**
 * Additional user pricing plan in all countries (except DK & SE)
 */
const ADDITIONAL_USER_PRICING_GENERIC: Array<AdditionalUsersPricing> = [
    {
        interval: BillingInterval.MONTHLY,
        countries: GENERIC_COUNTRIES,
        currencies: ['EUR', 'GBP'],
        withCashback: true,
        pricingTable: {
            ESSENTIAL: [
                {
                    amountOfUsers: '0-10',
                    price: 12.5,
                },
                {
                    amountOfUsers: '11-30',
                    price: 11.5,
                },

                {
                    amountOfUsers: '31-50',
                    price: 10.5,
                },
                {
                    amountOfUsers: '51-100',
                    price: 9.5,
                },
                {
                    amountOfUsers: '101-200',
                    price: 8.5,
                },
                {
                    amountOfUsers: '201-400',
                    price: 7.5,
                },
                {
                    amountOfUsers: '401-600',
                    price: 6.5,
                },
                {
                    amountOfUsers: '>600',
                    price: 5.5,
                },
            ],
            ADVANCED: [
                {
                    amountOfUsers: '0-10',
                    price: 14.5,
                },
                {
                    amountOfUsers: '11-30',
                    price: 13.5,
                },

                {
                    amountOfUsers: '31-50',
                    price: 12.5,
                },
                {
                    amountOfUsers: '51-100',
                    price: 11.5,
                },
                {
                    amountOfUsers: '101-200',
                    price: 10.5,
                },
                {
                    amountOfUsers: '201-400',
                    price: 9.5,
                },
                {
                    amountOfUsers: '401-600',
                    price: 8.5,
                },
                {
                    amountOfUsers: '>600',
                    price: 7.5,
                },
            ],
        },
    },
    {
        interval: BillingInterval.MONTHLY,
        countries: GENERIC_COUNTRIES,
        currencies: ['EUR', 'GBP'],
        withCashback: false,
        pricingTable: {
            ESSENTIAL: [
                {
                    amountOfUsers: '0-10',
                    price: 12.5,
                },
                {
                    amountOfUsers: '11-30',
                    price: 11.5,
                },

                {
                    amountOfUsers: '31-50',
                    price: 10.5,
                },
                {
                    amountOfUsers: '51-100',
                    price: 9.5,
                },
                {
                    amountOfUsers: '101-200',
                    price: 8.5,
                },
                {
                    amountOfUsers: '201-400',
                    price: 7.5,
                },
                {
                    amountOfUsers: '401-600',
                    price: 6.5,
                },
                {
                    amountOfUsers: '>600',
                    price: 5.5,
                },
            ],
            ADVANCED: [
                {
                    amountOfUsers: '0-10',
                    price: 14.5,
                },
                {
                    amountOfUsers: '11-30',
                    price: 13.5,
                },

                {
                    amountOfUsers: '31-50',
                    price: 12.5,
                },
                {
                    amountOfUsers: '51-100',
                    price: 11.5,
                },
                {
                    amountOfUsers: '101-200',
                    price: 10.5,
                },
                {
                    amountOfUsers: '201-400',
                    price: 9.5,
                },
                {
                    amountOfUsers: '401-600',
                    price: 8.5,
                },
                {
                    amountOfUsers: '>600',
                    price: 7.5,
                },
            ],
        },
    },
    {
        interval: BillingInterval.YEARLY,
        countries: GENERIC_COUNTRIES,
        currencies: ['EUR', 'GBP'],
        withCashback: true,
        pricingTable: {
            ESSENTIAL: [
                {
                    amountOfUsers: '0-10',
                    price: 11.5,
                },
                {
                    amountOfUsers: '11-30',
                    price: 10.5,
                },

                {
                    amountOfUsers: '31-50',
                    price: 9.5,
                },
                {
                    amountOfUsers: '51-100',
                    price: 8.5,
                },
                {
                    amountOfUsers: '101-200',
                    price: 7.5,
                },
                {
                    amountOfUsers: '201-400',
                    price: 7,
                },
                {
                    amountOfUsers: '401-600',
                    price: 6,
                },
                {
                    amountOfUsers: '>600',
                    price: 5,
                },
            ],
            ADVANCED: [
                {
                    amountOfUsers: '0-10',
                    price: 13.5,
                },
                {
                    amountOfUsers: '11-30',
                    price: 12.5,
                },

                {
                    amountOfUsers: '31-50',
                    price: 11.5,
                },
                {
                    amountOfUsers: '51-100',
                    price: 10.5,
                },
                {
                    amountOfUsers: '101-200',
                    price: 9.5,
                },
                {
                    amountOfUsers: '201-400',
                    price: 8.5,
                },
                {
                    amountOfUsers: '401-600',
                    price: 7.5,
                },
                {
                    amountOfUsers: '>600',
                    price: 6.5,
                },
            ],
        },
    },
    {
        interval: BillingInterval.YEARLY,
        countries: GENERIC_COUNTRIES,
        currencies: ['EUR', 'GBP'],
        withCashback: false,
        pricingTable: {
            ESSENTIAL: [
                {
                    amountOfUsers: '0-10',
                    price: 11.5,
                },
                {
                    amountOfUsers: '11-30',
                    price: 10.5,
                },

                {
                    amountOfUsers: '31-50',
                    price: 9.5,
                },
                {
                    amountOfUsers: '51-100',
                    price: 8.5,
                },
                {
                    amountOfUsers: '101-200',
                    price: 7.5,
                },
                {
                    amountOfUsers: '201-400',
                    price: 7,
                },
                {
                    amountOfUsers: '401-600',
                    price: 6,
                },
                {
                    amountOfUsers: '>600',
                    price: 5,
                },
            ],
            ADVANCED: [
                {
                    amountOfUsers: '0-10',
                    price: 13.5,
                },
                {
                    amountOfUsers: '11-30',
                    price: 12.5,
                },

                {
                    amountOfUsers: '31-50',
                    price: 11.5,
                },
                {
                    amountOfUsers: '51-100',
                    price: 10.5,
                },
                {
                    amountOfUsers: '101-200',
                    price: 9.5,
                },
                {
                    amountOfUsers: '201-400',
                    price: 8.5,
                },
                {
                    amountOfUsers: '401-600',
                    price: 7.5,
                },
                {
                    amountOfUsers: '>600',
                    price: 6.5,
                },
            ],
        },
    },
]

export default ADDITIONAL_USER_PRICING_GENERIC
